import script from "./TableRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TableRow.vue?vue&type=script&setup=true&lang=js"

import "./TableRow.vue?vue&type=style&index=0&id=67272e31&scoped=true&lang=css"

import exportComponent from "/var/www/TheIdFactory/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67272e31"]])

export default __exports__